<div class="bbody template01">
  <div class="container">
    <div class="template_001">

      <!-- Dynamic template name badge -->
      <div class="vf-type-badge">{{ templateName }}</div>

      <!-- HERO -->
      <section class="hero section_one section_two">
        <div class="avatar col img" *ngIf="photo == null">
          <img src="assets/images/john-doe-avatar.jpg" alt="profileImage" />
        </div>
        <div class="avatar col img" *ngIf="photo != null">
          <img [src]="imageSrc" alt="profileImage" />
        </div>
        <h1>{{ firstName + " " + lastName }}</h1>
        <p class="job">
          {{ jobTitle }}<ng-container *ngIf="jobTitle && companyName"> | </ng-container>{{ companyName }}
        </p>
        <div class="about" [innerHTML]="content"></div>

        <div class="facts" *ngIf="gpa || school || grade || height || age || weight">
          <span *ngIf="gpa"><b>GPA</b> {{ gpa }}</span>
          <span *ngIf="school"><b>School</b> {{ school }}</span>
          <span *ngIf="grade"><b>Grade</b> {{ grade }}</span>
          <span *ngIf="height"><b>Height</b> {{ height }}</span>
          <span *ngIf="age"><b>Age</b> {{ age }}</span>
          <span *ngIf="weight"><b>Weight</b> {{ weight }}</span>
        </div>
      </section>

      <!-- LINKS: social + custom buttons -->
      <section class="links social buttons-container">
        <a class="lbtn insta" [href]="instagram" target="_blank">
          <i class="ic fa-brands fa-instagram"></i><span>Instagram</span><i class="go fa-solid fa-chevron-right"></i>
        </a>
        <a class="lbtn youtube" [href]="youtube" target="_blank">
          <i class="ic fa-brands fa-youtube"></i><span>YouTube</span><i class="go fa-solid fa-chevron-right"></i>
        </a>
        <a class="lbtn linkedin" [href]="linkedin" target="_blank">
          <i class="ic fa-brands fa-linkedin-in"></i><span>LinkedIn</span><i class="go fa-solid fa-chevron-right"></i>
        </a>
        <a class="lbtn facebook" [href]="facebook" target="_blank">
          <i class="ic fa-brands fa-facebook-f"></i><span>Facebook</span><i class="go fa-solid fa-chevron-right"></i>
        </a>
        <a class="lbtn twitter" [href]="twitter" target="_blank">
          <i class="ic fa-brands fa-twitter"></i><span>Twitter</span><i class="go fa-solid fa-chevron-right"></i>
        </a>

        <ng-container *ngIf="buttons && buttons.length > 0 && buttons[0].LinkButtonTitle != ''">
          <ng-container *ngFor="let button of buttons">
            <a
              class="lbtn custom"
              *ngIf="button"
              [href]="button.LinkButtonLink"
              target="_blank"
              [style.background]="buttonColor || null"
            >
              <i class="ic fa-solid fa-link"></i><span>{{ button.LinkButtonTitle }}</span><i class="go fa-solid fa-chevron-right"></i>
            </a>
          </ng-container>
        </ng-container>
      </section>

      <!-- SHOWCASE: product images + logo -->
      <section class="showcase section_three">
        <div class="pic" *ngIf="productImages == null">
          <img src="assets/images/app-devices.jpg" alt="productImage" />
        </div>

        <ng-container *ngIf="productImages && productImages.length > 0 && showCarousel">
          <ngb-carousel [showNavigationArrows]="true">
            <ng-template ngbSlide *ngFor="let productImage of productImages">
              <div class="pic"><img [src]="productImage" alt="productImage" /></div>
            </ng-template>
          </ngb-carousel>
        </ng-container>

        <div class="brand">
          <img *ngIf="logo != null" [src]="imageSrcLogo" alt="logoimage" />
          <img *ngIf="logo == null" src="assets/images/unmasking-yourself.jpg" alt="logoimage" />
        </div>

        <div class="btn-wrapper">
          <a href="#" class="btn btn-primary btn-block more" [style.background]="buttonColor || null">Learn more</a>
        </div>
      </section>

      <section class="section_four">
        <img
          *ngIf="!youtubeArray || youtubeArray.length === 0"
          src="../images/template-img-001.jpg"
          alt=""
        />
        <div class="clearfix"><br /></div>
      </section>

      <!-- YouTube -->
      <ng-container *ngFor="let v of youtubeArray; trackBy: trackByIndex">
        <div class="video" *ngIf="v.youtubeLink | videoEmbed as src">
          <p>{{ v.youtubeTitle }}</p>
          <iframe
            [src]="src"
            [title]="v.youtubeTitle || 'YouTube player'"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </ng-container>

      <!-- Umyotube (YouTube / Dailymotion / umyovideo) -->
      <ng-container *ngFor="let v of umyotubeArray; trackBy: trackByIndex">
        <div class="video" *ngIf="v.umyotubeLink | videoEmbed as src">
          <p>{{ v.umyotubeTitle }}</p>
          <iframe
            [src]="src"
            title="Umyotube player"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </ng-container>

      <!-- Vimeo -->
      <ng-container *ngFor="let v of vimeoArray; trackBy: trackByIndex">
        <div class="video" *ngIf="v.vimeoVideoLink | videoEmbed as src">
          <p>{{ v.vimeoVideoTitle }}</p>
          <iframe
            [src]="src"
            [title]="v.vimeoVideoTitle || 'Vimeo player'"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </ng-container>

      <!-- CONTACT icons -->
      <section class="contact-icons">
        <a [href]="'tel:' + phone" [style.border-color]="buttonColor || null" title="Call">
          <i class="fa-solid fa-phone"></i>
        </a>
        <a [href]="'sms:' + phone" *ngIf="phoneAllow" [style.border-color]="buttonColor || null" title="Message">
          <i class="fa-solid fa-comments"></i>
        </a>
        <a [href]="'mailto:' + email" [style.border-color]="buttonColor || null" title="Email">
          <i class="fa-solid fa-envelope"></i>
        </a>
        <a [href]="'https://www.google.com/maps?q=' + address" [style.border-color]="buttonColor || null" title="Map">
          <i class="fa-solid fa-location-dot"></i>
        </a>
      </section>

      <div class="three-ctrls">
        <button type="button" class="ctrl-item" *ngIf="forwardCard" data-bs-toggle="modal" data-bs-target="#shareCard">
          <i class="fa-solid fa-share forward"></i>
          <h3>Forward</h3>
        </button>
        <a (click)="navigateToHome()" type="button" class="ctrl-item">
          <i class="fa-solid fa-right-to-bracket signup"></i>
          <h3>Sign Up</h3>
        </a>
        <button type="button" class="ctrl-item" *ngIf="saveCard" (click)="downloadVCard()">
          <i class="fa-solid fa-download save"></i>
          <h3>Save My Card</h3>
        </button>
      </div>

      <footer>
        <div class="qr" *ngIf="qrCodeImage">
          <img [src]="qrCodeImage" alt="QR Code" />
        </div>
        <div class="clearfix"><br /></div>
      </footer>
      <footer>
        <p class="strip">People <i></i> Opportunities <i></i> Impact</p>
        <p class="powered">This card is powered by <span>UMYO Cards</span></p>
        <form action="" class="referal-form" *ngIf="inviteCode">
          <label for="referal">Referral ID: </label>
          <input type="text" name="referal" id="referal" [value]="referal" disabled placeholder="XXXXX" />
        </form>
        <a [routerLink]="['/']" class="call-to-action">
          <span class="left">Click<br />Here</span>
          <span class="right">Design your card now!</span>
        </a>
      </footer>

    </div>
  </div>
</div>
